export default "__VITE_ASSET__7aHwf2tpT9645N1YtxgDqg__"